import { ChipGroup, FilterChip } from '@zillow/constellation-10';
import { emitBuyingPillClickEvent } from '../../constants/clickstreamEvents/inboxIA';

export default function RentingBuyingPills() {
  const handleBuyingClick = () => {
    emitBuyingPillClickEvent();
    window.location.href = '/myzillow/inbox';
  };

  return (
    <ChipGroup aria-label="Renting or buying" selected="renting" css={{ marginLeft: 'default' }}>
      <FilterChip value="renting">Renting</FilterChip>
      <FilterChip value="buying" onClick={handleBuyingClick}>
        Buying
      </FilterChip>
    </ChipGroup>
  );
}
